module.exports = __webpack_public_path__ + "static/media/onboarding_logo.bba82192.png";